import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { get_form_url } from '@/utils/formUtils';

export default function AboutPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于073漫画网 - 免费韩国漫画阅读平台',
    description: '073漫画网是专业的免费韩国漫画阅读平台，致力于为中文读者提供高质量的韩国漫画阅读体验。了解我们的品牌故事、用户口碑和联系方式。',
    isPartOf: { '@type': 'WebSite', name: '073漫画网', url: 'https://073mh.com' },
    about: {
      '@type': 'Organization',
      name: '073漫画网',
      description: '免费韩国漫画阅读平台，每日更新海量热门韩国漫画',
    },
  };

  const testimonials = [
    {
      name: '小明',
      avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20boy%20avatar%20portrait%2C%20simple%20background%2C%20warm%20colors%2C%20Korean%20webtoon%20style&width=80&height=80&seq=avatar-01&orientation=squarish',
      content: '073漫画网真的是我见过最好用的漫画网站！更新速度快，画质清晰，而且完全免费。蜜桃少年追了好久，每次更新都第一时间来看！',
      date: '2026-07-15',
    },
    {
      name: '小红',
      avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20girl%20avatar%20portrait%2C%20simple%20background%2C%20warm%20colors%2C%20Korean%20webtoon%20style&width=80&height=80&seq=avatar-02&orientation=squarish',
      content: '分类很齐全，找漫画特别方便。翻译质量也很高，读起来很流畅。已经推荐给好多朋友了，大家都说好用！',
      date: '2026-07-20',
    },
    {
      name: '阿强',
      avatar: 'https://readdy.ai/api/search-image?query=Cool%20anime%20style%20male%20avatar%20portrait%2C%20simple%20background%2C%20warm%20colors%2C%20Korean%20webtoon%20style&width=80&height=80&seq=avatar-03&orientation=squarish',
      content: '页面设计简洁清爽，没有乱七八糟的广告，阅读体验特别棒。电脑和手机都能看，通勤路上必备！',
      date: '2026-08-01',
    },
    {
      name: '小美',
      avatar: 'https://readdy.ai/api/search-image?query=Beautiful%20anime%20style%20female%20avatar%20portrait%2C%20simple%20background%2C%20warm%20colors%2C%20Korean%20webtoon%20style&width=80&height=80&seq=avatar-04&orientation=squarish',
      content: '作为一个重度漫画爱好者，073漫画网完全满足了我的需求。收藏了好多喜欢的作品，每天上来追更已经成了习惯！',
      date: '2026-08-03',
    },
  ];

  const stats = [
    { label: '总漫画数', value: '5000+', icon: 'ri-book-open-line' },
    { label: '日活跃用户', value: '50万+', icon: 'ri-user-line' },
    { label: '月更新量', value: '3000+', icon: 'ri-upload-2-line' },
    { label: '用户评分', value: '4.8', icon: 'ri-star-line' },
  ];

  return (
    <div className="min-h-screen bg-background-50">
      <script type="application/ld+json">{JSON.stringify(aboutSchema)}</script>

      <Navbar />

      <main className="max-w-7xl mx-auto px-4 md:px-6 py-4">
        <Breadcrumb
          items={[
            { label: '首页', href: '/' },
            { label: '关于我们' },
          ]}
        />

        {/* Hero */}
        <section className="text-center py-16">
          <h1 className="text-3xl md:text-4xl font-bold text-foreground-950 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
            关于 <span className="text-primary-500">073漫画网</span>
          </h1>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            073漫画网是一个专注于免费韩国漫画阅读的平台。我们致力于为中文读者提供最优质的韩国漫画资源，
            让每一位漫画爱好者都能在这里找到属于自己的快乐。无论是热门的BL漫画、恋爱漫画，还是奇幻、动作类作品，
            073漫画网都已为您精心准备。
          </p>
        </section>

        {/* Stats */}
        <section className="mb-16">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {stats.map((stat) => (
              <div key={stat.label} className="bg-background-50 border border-background-200/70 rounded-xl p-6 text-center">
                <div className="w-11 h-11 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-3">
                  <i className={`${stat.icon} text-primary-500 text-lg`}></i>
                </div>
                <div className="text-2xl md:text-3xl font-bold text-foreground-950 mb-1" style={{ fontFamily: 'var(--font-heading)' }}>
                  {stat.value}
                </div>
                <div className="text-xs text-foreground-500">{stat.label}</div>
              </div>
            ))}
          </div>
        </section>

        {/* Brand Story */}
        <section className="mb-16">
          <h2 className="text-2xl font-bold text-foreground-950 mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
            品牌故事
          </h2>
          <div className="bg-background-50 border border-background-200/70 rounded-xl p-8">
            <div className="max-w-3xl">
              <p className="text-foreground-600 text-sm leading-relaxed mb-4">
                073漫画网诞生于对漫画的热爱。我们的创始团队是一群资深的漫画爱好者，深知找不到高质量、免费且更新及时的
                韩国漫画是多么令人沮丧的事情。于是，073漫画网应运而生。
              </p>
              <p className="text-foreground-600 text-sm leading-relaxed mb-4">
                我们与多家韩国漫画版权方建立了合作关系，确保每一部作品都经过正版授权。同时，我们组建了专业的翻译团队，
                力求在最短的时间内将最新的韩国漫画章节以最优质的中文呈现给读者。
              </p>
              <p className="text-foreground-600 text-sm leading-relaxed mb-4">
                从最初的几十部作品，到现在拥有超过5000部漫画的庞大书库，073漫画网始终秉持着"让好漫画触手可及"的初心。
                我们相信，好的漫画作品应该被更多人看到，而语言不应成为阅读的障碍。
              </p>
              <p className="text-foreground-600 text-sm leading-relaxed">
                未来，073漫画网将继续拓展漫画资源，优化阅读体验，为中文漫画爱好者打造一个更加完美的阅读平台。
                感谢每一位读者的支持，是你们让073漫画网不断成长。
              </p>
            </div>
          </div>
        </section>

        {/* User Testimonials */}
        <section id="reputation" className="mb-16">
          <h2 className="text-2xl font-bold text-foreground-950 mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
            用户口碑
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {testimonials.map((item, idx) => (
              <div key={idx} className="bg-background-50 border border-background-200/70 rounded-xl p-6">
                <div className="flex items-center gap-3 mb-4">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-10 h-10 rounded-full object-cover"
                  />
                  <div>
                    <div className="text-sm font-semibold text-foreground-950">{item.name}</div>
                    <div className="text-xs text-foreground-400">{item.date}</div>
                  </div>
                  <div className="ml-auto flex items-center gap-0.5">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <i key={star} className="ri-star-fill text-accent-500 text-sm"></i>
                    ))}
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.content}
                </p>
              </div>
            ))}
          </div>
        </section>

        {/* Contact */}
        <section id="contact" className="mb-16">
          <h2 className="text-2xl font-bold text-foreground-950 mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
            联系我们
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-primary-500 text-lg"></i>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-950 mb-1">电子邮件</h3>
                  <p className="text-sm text-foreground-500">contact@073mh.com</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-wechat-line text-accent-500 text-lg"></i>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-950 mb-1">微信公众号</h3>
                  <p className="text-sm text-foreground-500">搜索"073漫画网"关注我们</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-global-line text-secondary-500 text-lg"></i>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-950 mb-1">官方网站</h3>
                  <p className="text-sm text-foreground-500">https://073mh.com</p>
                </div>
              </div>
            </div>

            <div className="bg-background-50 border border-background-200/70 rounded-xl p-6">
              <h3 className="text-lg font-bold text-foreground-950 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
                给我们留言
              </h3>
              <form
                data-readdy-form
                className="space-y-4"
                onSubmit={async (e) => {
                  e.preventDefault();
                  const form = e.currentTarget;
                  const honeypot = (form.querySelector('[name="phone_alt"]') as HTMLInputElement)?.value?.trim();
                  if (honeypot) {
                    alert('留言已提交，感谢您的反馈！');
                    return;
                  }
                  try {
                    const formUrl = await get_form_url('073漫画网 - 联系我们留言表单');
                    const formData = new FormData(form);
                    const res = await fetch(formUrl, {
                      method: 'POST',
                      body: new URLSearchParams(formData as unknown as Record<string, string>),
                      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    });
                    const responseText = await res.text();
                    let parsed;
                    try { parsed = JSON.parse(responseText); } catch { parsed = null; }
                    const code = parsed?.code;
                    if (res.ok && code === 'OK') {
                      alert('留言已提交，感谢您的反馈！我们会尽快回复您。');
                      (form as HTMLFormElement).reset();
                    } else {
                      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '提交失败，请稍后重试';
                      alert(serverMsg);
                    }
                  } catch {
                    alert('提交失败，请检查网络后重试');
                  }
                }}
              >
                <div>
                  <label htmlFor="about-name" className="block text-sm text-foreground-700 mb-1.5">姓名</label>
                  <input
                    id="about-name"
                    name="name"
                    type="text"
                    required
                    className="w-full px-3 py-2.5 border border-background-200 rounded-lg text-sm bg-background-50 text-foreground-950 focus:outline-none focus:border-primary-500 transition-colors"
                    placeholder="请输入您的姓名"
                  />
                </div>
                <div>
                  <label htmlFor="about-email" className="block text-sm text-foreground-700 mb-1.5">邮箱</label>
                  <input
                    id="about-email"
                    name="email"
                    type="email"
                    required
                    className="w-full px-3 py-2.5 border border-background-200 rounded-lg text-sm bg-background-50 text-foreground-950 focus:outline-none focus:border-primary-500 transition-colors"
                    placeholder="请输入您的邮箱"
                  />
                </div>
                <div>
                  <label htmlFor="about-message" className="block text-sm text-foreground-700 mb-1.5">留言内容</label>
                  <textarea
                    id="about-message"
                    name="message"
                    required
                    maxLength={500}
                    rows={4}
                    className="w-full px-3 py-2.5 border border-background-200 rounded-lg text-sm bg-background-50 text-foreground-950 focus:outline-none focus:border-primary-500 transition-colors resize-none"
                    placeholder="请输入您的留言（最多500字）"
                  ></textarea>
                  <p className="text-xs text-foreground-400 mt-1">最多500个字符</p>
                </div>
                <input
                  name="phone_alt"
                  type="text"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="absolute opacity-0 pointer-events-none"
                  style={{ position: 'absolute', opacity: 0, pointerEvents: 'none', height: 0 }}
                />
                <button
                  type="submit"
                  className="w-full bg-primary-500 text-background-50 py-2.5 rounded-lg text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  提交留言
                </button>
              </form>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}